// extracted by mini-css-extract-plugin
export default {"outerDiv":"SkipedPage_outerDiv__nP6RA","innerDiv":"SkipedPage_innerDiv__-UObP","backBtn":"SkipedPage_backBtn__AHk-X"};